import React from 'react';
import { connect } from 'react-redux';
import ArrayHelper from 'foundation/array-helper';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import AlertBar from './alert-bar';

class AlertBarsLayout extends React.Component {
    componentDidMount() {
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(endpointNames.LIVE_SCANNER);
    }

    render() {
        const { liveScanner } = this.props;

        if (!liveScanner || ArrayHelper.isEmpty(liveScanner.alertBars)) return null;

        return liveScanner.alertBars.map((alertBar) => {
            return <AlertBar model={alertBar} key={alertBar.lastUpdated} />;
        });
    }
}

const mapStateToProps = (state) => ({
    liveScanner: state.scoring[endpointNames.LIVE_SCANNER],
});

const AlertBarsLayoutContainer = connect(
    mapStateToProps,
    null
)(AlertBarsLayout);

export default AlertBarsLayoutContainer;
